<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <a
          class="btn btn-primary"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#AddCategorieClientModal"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter une catégorie client
        </a>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black"
            placeholder="Rechercher une catégorie client"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Code
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Libellé
              </th>
              <!-- <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Clients
              </th> -->
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date de création
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(categorieClient, index) in categorieClients" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ categorieClient.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ categorieClient.libelle }}
              </td>
              <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ categorieClient.clients?.map(client => `${client.nomClient ? client.nomClient : ''} ${client.prenomClient ? client.prenomClient : ''} ${client.raisonSociale ? client.raisonSociale : ''}`).join(', ') || '-' }}
              </td> -->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(categorieClient.createdAt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Actions
                </button>
                <ul class="dropdown-menu dropdown-block" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(267px, 305px);" data-popper-placement="bottom-start">
                  <li class="dropdown-item d-flex align-items-center">
                    <a
                      class="dropdown-item d-flex align-items-center"
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#AddCategorieClientModal"
                      @click="moddifier(categorieClient)"
                    >
                      <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                      Modifier
                    </a>
                  </li>
                  <li class="dropdown-item d-flex align-items-center">
                    <a
                      class="dropdown-item d-flex align-items-center"
                      href="javascript:void(0);"
                      @click="suppression(categorieClient.id, categorieClients, 'categorieClients', `la catégorie client ${categorieClient.libelle}`)"
                    >
                      <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                      Supprimer
                    </a>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
  <AddCategorieClientModal :item="selectedItem" @close="recharger" />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import Swal from 'sweetalert2';
import { CategorieClient } from '@/models/CategorieClient';
import ApiService from '@/services/ApiService';
import { suppression, error, format_date } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from '@/services/JwtService';
import AddCategorieClientModal from './AddCategorieClientModal.vue';

export default defineComponent({
  name: 'ListeCategorieClient',
  components: {
    PaginationComponent,
    AddCategorieClientModal,
  },
  setup() {
    onMounted(() => {
      getAllCategorieClient();
    });

    const categorieClients = ref<Array<CategorieClient>>([]);
    const categorieClient = ref<CategorieClient>();
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const selectedItem = ref(0);

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      try {
        page.value = page_;
        getAllCategorieClient(page_, limit_);
      } catch (err) {
        error('Erreur lors de la pagination');
      }
    };

    function rechercher() {
      getAllCategorieClient(page.value, limit.value, searchTerm.value);
    }

    const recharger = () => {
      getAllCategorieClient();
    };

    function getAllCategorieClient(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/categorieClient?page=${page}&limit=${limi}&mot=${searchTerm}`)
        .then(({ data }) => {
          categorieClients.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    function moddifier(editCategorieClient: CategorieClient) {
      categorieClient.value = editCategorieClient;
      selectedItem.value = editCategorieClient.id;
    }

    const deleteCategorieClient = (id: number) => {
      ApiService.delete(`/categorieClients/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false,
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Réessayer à nouveau!',
            heightAuto: false,
            customClass: {
              confirmButton: 'btn fw-semobold btn-light-danger',
            },
          });
        });

      for (let i = 0; i < categorieClients.value.length; i++) {
        if (categorieClients.value[i].id === id) {
          categorieClients.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    return {
      categorieClients,
      checkPermission,
      getAllCategorieClient,
      deleteCategorieClient,  
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      selectedItem,
      recharger,
      format_date,
    };
  },
});
</script>